import React from 'react';
import { Skeleton } from '@mui/material';
import { getTransactionStatusLabel } from '../utils';
import { BulletStatus } from 'components/bullet-status/bullet-status';
import {
    Transaction,
    TransactionStatus,
} from 'features/gateways/types/transaction.types';
import { BulletStatusProps } from 'components/bullet-status/types';

const transactionStatusMapToBulletType: Record<
    TransactionStatus,
    BulletStatusProps['type']
> = {
    created: 'warning',
    callback_success: 'success',
    callback_unsuccess: 'error',
    interface: 'success',
    bank: 'warning',
    verify_success: 'success',
    verify_unsuccess: 'error',
    sandbox: 'warning',
    revers: 'error',
    cancel: 'error',
    withdraw_pending: 'warning',
    withdraw_success: 'success',
    expire: 'error',
};

const TransactionStatusBullet: React.FC<{ status?: Transaction['status'] }> = ({
    status,
}) => {
    if (!status) {
        return <Skeleton width={90} height={52} />;
    }

    return (
        <BulletStatus
            type={transactionStatusMapToBulletType[status] || 'error'}
            label={getTransactionStatusLabel(status)}
        />
    );
};

export default TransactionStatusBullet;
